<template>
  <div class="air_ListBox">
    <div class="search-form">
      <el-row type="flex" :gutter="20" align="middle">
        <el-col class="el-col-label" :span="8">
          <span>PNR:</span>
          <input clearable v-model="searchForm.pnr" @keyup.enter="getList">
        </el-col>
        <el-col class="el-col-label" :span="8">
          <span>订单号:</span>
          <input clearable v-model="searchForm.orderNo" @keyup.13="getList">
        </el-col>
        <el-col class="el-col-label" :span="8">
          <span>票号:</span>
          <input clearable v-model="searchForm.ticketNumber" @keyup.13="getList">
        </el-col>
      </el-row>
      <el-row :gutter="20" type="flex" align="middle" style="margin-top:10px;">
        <el-col class="el-col-label" :span="8">
          <span>航司:</span>
          <!-- <el-select clearable placeholder="" v-model="searchForm.airCode">
            <el-option
              v-for="item in airlineList"
              :key="item.id"
              :label="item.airCompanyName"
              :value="item.airlineCode"
            ></el-option>
          </el-select>-->
          <AirlineSelect v-model="searchForm.airCode"/>
        </el-col>
        <el-col class="el-col-label" :span="8">
          <span>乘客姓名:</span>
          <input clearable v-model="searchForm.psgName" @keyup.13="getList">
        </el-col>
        <el-col class="el-col-label" :span="8">
          <span>下单日期:</span>
          <el-date-picker
            v-model="searchForm.orderTimeStart"
            type="date"
            placeholder=""
            class="time_box"
            @change="getDate('orderTimeStart')"
          ></el-date-picker>
        </el-col>
      </el-row>
      <!-- <el-row :gutter="20" type="flex" align="middle" style="margin-top:10px;">
        <el-col :span="8" class="el-col-label">
          <span>航班号:</span>
          <input clearable v-model="searchForm.flightNo" @keyup.13="getList">
        </el-col>
        <el-col :span="8" class="el-col-label">
          <span>联系电话:</span>
          <input clearable v-model="searchForm.contactTel" @keyup.13="getList">
        </el-col>
        <el-col :span="8" class="el-col-label">
          <span>证件号:</span>
          <input clearable v-model="searchForm.psgCardNo" @keyup.13="getList">
        </el-col>
      </el-row>-->
      <el-row type="flex" align="middle" style="margin-top:10px;">
        <el-col class="el-col-label" :span="8">
          <span>航变日期:</span>
          <el-date-picker
            v-model="searchForm.beginDate"
            type="date"
            placeholder=""
            class="time_box"
            @change="getDate('beginDate')"
          ></el-date-picker>
        </el-col>
      </el-row>
      <div class="btn_box">
        <el-button type="primary" @click="getList" size="small">搜索</el-button>
        <el-button type="" @click="reset" size="small">重置</el-button>
      </div>
    </div>
    <el-row>
      <el-col :span="24">
        <el-table :data="tableData" v-loading="loading" style="width: 100%" class="font-12">
          <el-table-column label="航变时间" width="100" class-name="fz12" align="center">
            <template slot-scope="scope">{{scope.row.changeDT}}</template>
          </el-table-column>
          <el-table-column label="订单号/PNR" align="center" prop="orderNo"></el-table-column>
          <el-table-column label="航班信息" class-name="fz12" align="center" width="130">
            <template slot-scope="scope">
              <p>
                {{scope.row.depCityName + scope.row.depCityCode}}-
                {{scope.row.arrCityName + scope.row.arrCityCode}}
              </p>
              <p>{{scope.row.flightNo}}</p>
            </template>
          </el-table-column>
          <el-table-column label="航班日期" class-name="fz12" align="center" width="90">
            <template slot-scope="scope">
              <p>{{scope.row.depDate}}</p>
              <p>{{scope.row.depTime}}</p>
            </template>
          </el-table-column>
          <el-table-column label="航变信息" class-name="fz12" align="center" width="130">
            <template slot-scope="scope">
              <p>
                {{scope.row.changeBeginCityName + scope.row.changeBeginCityCode}}-
                {{scope.row.changeArriveCityName + scope.row.changeArriveCityCode}}
              </p>
              <p>{{scope.row.changeFlightNo}}</p>
            </template>
          </el-table-column>
          <el-table-column label="航变日期" width="90" class-name="fz12" align="center">
            <template slot-scope="scope">
              <p>{{scope.row.changeBeginDate}}-{{scope.row.changeBeginTime}}</p>
            </template>
          </el-table-column>
          <el-table-column label="变动原因" width="100" class-name="fz12" align="center">
            <template slot-scope="scope">{{scope.row.remark}}</template>
          </el-table-column>
          <el-table-column label="乘机人" width="80" class-name="fz12" align="center">
            <template slot-scope="scope">
              <span v-for="(psg,index) in scope.row.psg" :key="index">{{index+1}}、{{psg.psgName}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="状态"
            width="80"
            class-name="fz12"
            align="center"
            prop="orderStatusText"
          ></el-table-column>
          <el-table-column fixed="right" label="操作" width="80" class-name="fz12" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                v-show="scope.row.orderStatus==11"
                @click="setOrdersNo(scope.row.orderNo)"
              >支付</el-button>
              <el-button type="text" size="small" @click="goOrderInfo(scope.row.orderNo)">查看订单</el-button>
              <el-button
                type="text"
                size="mini"
                v-show="scope.row.orderStatus == 22"
                @click="$router.push({name:'air-ticket-admin-ticketChanging',query:{ordersNo:scope.row.orderNo}})"
              >申请改签</el-button>
              <el-button
                type="text"
                size="mini"
                v-show="scope.row.orderStatus == 22"
                @click="$router.push({name:'air-ticket-admin-dishonour',query:{ordersNo:scope.row.orderNo}})"
              >申请退票</el-button>
              <el-button
                type="text"
                size="small"
                v-show="scope.row.orderStatus==11"
                @click="cancel(scope.row.orderNo)"
              >取消订单</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-col style="margin-top:10px">
      <el-pagination
        @current-change="handleCurrentChange"
        background=""
        :current-page="searchForm.currentPage"
        :page-sizes="[10, 20, 30, 40,50]"
        :page-size="searchForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalPage"
      ></el-pagination>
    </el-col>
  </div>
</template>

<script>
import flightAirlines from "@/lib/data-service/flight/flight_domestic_airlines";
import airborneList from "@/lib/data-service/flight/flight_domestic_buyer_manage_order_airborneList";
import scrollTop from "@/lib/common-service/scrollTop";
import order_cancel from "@/lib/data-service/flight/flight_domestic_buyer_white_order_cancel";
import AirlineSelect from "../components/airlineSelect";

export default {
  data() {
    return {
      searchForm: {
        currentPage: 1,
        pageSize: 10
      },
      totalPage: 0,
      list: [],
      tableData: [],
      loading: false,
      airlineList: [] //航线公司
    };
  },
  components: { AirlineSelect },
  created() {
    this._flightAirlines();
    this.getList();
  },
  methods: {
    getList() {
      this.loading = true;
      let data = this.searchForm;
      airborneList(data).then(res => {
        console.log(res);
        this.loading = false;
        this.tableData = res.pageResult.pageData;
        this.totalPage = res.pageResult.totalCount;
        scrollTop(500);
      });
    },
    recharge() {
      this.searchForm = {};
    },
    setOrdersNo(val) {
      this.$router.push({
        name: "订单支付",
        query: {
          ordersNo: val
        }
      });
    },
    goOrderInfo(val) {
      this.$router.push({
        name: "air-ticket-admin-airDetails",
        query: {
          ordersNo: val
        }
      });
    },
    handleCurrentChange(val) {
      this.searchForm.currentPage = val;
      this.getList();
    },
    _flightAirlines() {
      flightAirlines().then(res => {
        if (res.code === this.SUCCESS_CODE) {
          this.airlineList = res.pageResult.pageData;
        }
      });
    },
    reset() {
      this.searchForm = {};
      this.searchForm.currentPage = 1;
      this.searchForm.pageSize = 10;
      this.getList();
    },
    cancel(val) {
      let data = {
        orderNo: val
      };
      this.$prompt("请输入取消原因：", "取消订单", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(({ value }) => {
          if (!value)
            return this.$message({
              type: "warning",
              message: "请填写取消原因"
            });
          data.remark = value;
          order_cancel(data).then(res => {
            console.log(res);
            this.getList();
          });
        })
        .catch(() => {});
    },
    getDate(name) {
      let data = this.searchForm;
      data[name] = this.$moment(data[name]).format("YYYY-MM-DD");
      this.getList();
    }
  }
};
</script>
<style lang="less" scoped>
.air_ListBox {
  border-top: 3px solid #237dc9;
  width: 100%;
}
.search-form {
  padding: 20px;
  margin-bottom: 10px;
  background: #f4f9ff;
  span {
    width: 75px;
    font-size: 14px;
    display: inline-block;
  }
  .el-col-label {
    input {
      display: inline-block;
      border: 1px solid #dcdfe6;
      font-size: inherit;
      height: 30px;
      border-radius: 0;
      width: 180px;
      font-size: 12px;
      line-height: 40px;
      outline: 0;
      padding: 0 15px;
      box-sizing: border-box;
    }
    /deep/.el-input__inner {
      display: inline-block;
      border: 1px solid #dcdfe6;
      font-size: inherit;
      height: 30px;
      border-radius: 0;
      width: 180px;
      font-size: 12px;
      line-height: 40px;
      outline: 0;
      padding: 0 15px;
      box-sizing: border-box;
    }
    /deep/.el-input__icon {
      line-height: 30px;
    }
    /deep/.el-date-editor.el-input {
      width: unset;
      display: inline-block;
    }
    .time_box /deep/.el-input__inner {
      padding: 0 30px;
      line-height: 30px;
    }
  }
}
.el-button {
  border-radius: 0;
}
.btn_box {
  margin: 0 auto;
  margin-top: 10px;
  display: flex;
  justify-content: center;
}
.nav_tab {
  /deep/.el-tabs__nav-wrap {
    background: #f1f4fb;
    padding: 0 20px;
  }
  /deep/.el-tabs__nav-wrap::after {
    background-color: unset;
  }
  /deep/.el-tabs__item.is-active {
    font-size: 12px;
    background: #fff;
    padding: 0 15px;
  }
  /deep/.el-tabs__item {
    font-size: 12px;
  }
  /deep/.el-tabs__active-bar {
    box-sizing: content-box;
    padding: 0 15px;
    top: 0;
    height: 3px;
    left: -15px;
  }
}
.fz12 {
  font-size: 12px;
  button {
    margin: 0;
  }
}
</style>
